module.exports = ".registerButton\r\n{\r\n    float: center;\r\n    text-align: center;\r\n    width:100%;\r\n    margin-right:550px;\r\n    margin-left:350px;\r\n    position: fixed;\r\n\r\n}\r\n.rightButton\r\n{\r\n    float: right;\r\n    text-align: right;\r\n    width:100%;\r\n    margin-right:550px;\r\n}\r\n#mydiv\r\n{ margin: auto; max-width: 1000px;\r\n}\r\n.roolover button{\r\n    margin: 10px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/Components/TowLocate/help-page/help-page.component.css
// module id = ./src/app/Components/TowLocate/help-page/help-page.component.css
// module chunks = main